import { IFrameNavButton } from "../atoms/IFrameNavButton";
import { useMeganAdapter } from "adapters/megan";

const MeganButton = () => {
  const props = useMeganAdapter("meganButton");
  return <IFrameNavButton {...props} />;
};

export { MeganButton };
